import styled from "styled-components";
import { HighlightProps } from "./UserCard.types";

export const UserCardWrapper = styled.div<HighlightProps>`
  display: flex;
  background: ${props => props.$Highlight ? props.theme.HighlightColour : 'none'};
  color: ${props => props.$Highlight ? props.theme.HighlightTextColour : props.theme.TextColour};
  border-radius: 100px;
  padding: 0.25em;
`